import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import VehicleSearchAdWrapper from 'src/apps/ads/components/VehicleSearchAdWrapper.vue';
import {computed} from 'vue';
import { useSearchStore } from 'src/apps/search/store'



export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleSearchAd',
  props: {
  pos: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const props = __props

const searchStore = useSearchStore()

const currentAd = computed(() => {
  try {
    return searchStore.vehicleSearchAds[props.pos]
  } catch (e) {
    console.error(e)
    return null
  }
})


return (_ctx: any,_cache: any) => {
  return (currentAd.value)
    ? (_openBlock(), _createBlock(VehicleSearchAdWrapper, {
        key: 0,
        "ad-data": currentAd.value
      }, null, 8, ["ad-data"]))
    : _createCommentVNode("", true)
}
}

})